import ErrorNotFound from './errorNotFound'

export default ErrorNotFound
